import { nextTick } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f12407f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = ["onClick"];
import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
import { message } from 'ant-design-vue';
import MenuFormModal from './MenuFormModal.vue';
// 导入菜单管理API
import { getResourceList, sortResource } from '@/api/menuMangeApi';
import { awaitWrap, OK } from '@/common';
// 修改VxeTable引用的类型
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuTableBlock',
  setup(__props, {
    expose
  }) {
    const tableRef = ref();
    // 状态管理
    const loading = ref(false);
    const tableData = ref([]);
    const searchParams = reactive({
      menuName: ''
    });
    const modalVisible = ref(false);
    const modalType = ref('add');
    const formState = reactive({
      id: '',
      menuId: '',
      name: '',
      resType: 1,
      parentId: '',
      priority: 1,
      permission: '',
      icon: '',
      url: ''
    });
    const tableHeight = ref(0);
    const menuFormModalRef = ref(null);
    // 父级菜单选项
    const parentMenuOptions = ref([]);
    // 子级菜单选项
    const subMenuOptions = ref([]);
    // VxeTable配置
    const rowConfig = reactive({
      drag: true
    });
    const rowDragConfig = reactive({
      isCrossDrag: false,
      isPeerDrag: true,
      disabledMethod: row => {
        var _row$row;
        return ((_row$row = row.row) === null || _row$row === void 0 ? void 0 : _row$row.resType) === 3;
      }
    });
    const columnConfig = reactive({});
    const treeConfig = reactive({
      transform: true,
      rowField: 'menuId',
      parentField: 'parentId'
    });
    // 获取所有可用作父级的菜单
    const getAllParentMenus = menus => {
      let result = [];
      menus.forEach(menu => {
        if (menu.resType === 1) {
          var _menu$id, _menu$menuId;
          result.push({
            id: ((_menu$id = menu.id) === null || _menu$id === void 0 ? void 0 : _menu$id.toString()) || '',
            menuId: ((_menu$menuId = menu.menuId) === null || _menu$menuId === void 0 ? void 0 : _menu$menuId.toString()) || '',
            name: menu.name,
            resType: menu.resType,
            parentId: menu.parentId,
            priority: menu.priority,
            permission: menu.permission
          });
        }
        if (menu.children && menu.children.length > 0) {
          result = result.concat(getAllParentMenus(menu.children));
        }
      });
      return result;
    };
    // 获取所有可用作子级的菜单
    const getAllSubMenus = menus => {
      let result = [];
      menus.forEach(menu => {
        if (Number(menu.resType) === 2) {
          var _menu$id2, _menu$menuId2;
          result.push({
            id: ((_menu$id2 = menu.id) === null || _menu$id2 === void 0 ? void 0 : _menu$id2.toString()) || '',
            menuId: ((_menu$menuId2 = menu.menuId) === null || _menu$menuId2 === void 0 ? void 0 : _menu$menuId2.toString()) || '',
            name: menu.name,
            resType: menu.resType,
            parentId: menu.parentId,
            priority: menu.priority,
            permission: menu.permission,
            url: menu.url
          });
        }
        if (menu.children && menu.children.length > 0) {
          result = result.concat(getAllSubMenus(menu.children));
        }
      });
      return result;
    };
    // 计算表格高度
    const calculateTableHeight = () => {
      tableHeight.value = window.innerHeight - 54 - 32 - 102 - 48 - 55;
      document.documentElement.style.setProperty('--table-height', `${tableHeight.value + 60}px`);
    };
    // 监听窗口大小变化
    const handleResize = () => {
      calculateTableHeight();
    };
    // 通过参数筛选数据
    const searchData = params => {
      searchParams.menuName = params.menuName;
      fetchMenuList();
    };
    // 向父组件暴露的方法和属性
    expose({
      searchData
    });
    // 生命周期钩子
    onMounted(() => {
      calculateTableHeight();
      window.addEventListener('resize', handleResize);
      fetchMenuList();
    });
    // 组件卸载时移除事件监听
    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize);
    });
    // 获取菜单列表
    const fetchMenuList = async () => {
      loading.value = true;
      try {
        loading.value = false;
        // 更新父级菜单选项，这里需要使用原始的树形数据
        const [err, res] = await awaitWrap(getResourceList(searchParams));
        if (res && res.code === OK) {
          // 转换数据格式
          const convertData = items => {
            return items.map(item => {
              var _item$id, _item$menuId, _item$parentId;
              // 创建转换后的对象
              const convertedItem = {
                id: (_item$id = item.id) === null || _item$id === void 0 ? void 0 : _item$id.toString(),
                menuId: (_item$menuId = item.menuId) === null || _item$menuId === void 0 ? void 0 : _item$menuId.toString(),
                name: item.name,
                resType: item.resType,
                parentId: (_item$parentId = item.parentId) === null || _item$parentId === void 0 ? void 0 : _item$parentId.toString(),
                priority: item.priority,
                permission: item.permission,
                icon: item.icon,
                url: item.url
              };
              // 递归处理children
              if (item.children && item.children.length > 0) {
                convertedItem.children = convertData(item.children);
              }
              return convertedItem;
            });
          };
          // 转换API返回的数据
          const convertedData = convertData(res.data);
          // 更新父级菜单选项
          parentMenuOptions.value = getAllParentMenus(convertedData);
          subMenuOptions.value = getAllSubMenus(convertedData);
          // 将嵌套的树形菜单数据扁平化处理成一维数组
          const flattenMenuData = menuItems => {
            const result = [];
            const processItem = item => {
              // 复制当前项，但不包括children属性
              const {
                children,
                ...itemWithoutChildren
              } = item;
              result.push(itemWithoutChildren);
              // 处理子项
              if (children && children.length > 0) {
                children.forEach(child => processItem(child));
              }
            };
            menuItems.forEach(item => processItem(item));
            return result;
          };
          // 直接扁平化
          tableData.value = flattenMenuData(convertedData);
        }
        if (err) {
          message.error('获取菜单列表失败');
        }
      } catch (error) {
        console.error('获取菜单列表失败', error);
        message.error('获取菜单列表失败');
        loading.value = false;
      }
    };
    // 新增菜单
    const handleAddMenu = () => {
      modalType.value = 'add';
      modalVisible.value = true;
      nextTick(() => {
        if (menuFormModalRef.value) {
          menuFormModalRef.value.clearFormData();
        }
      });
    };
    // 编辑菜单
    const handleEdit = record => {
      modalType.value = 'edit';
      Object.assign(formState, record);
      modalVisible.value = true;
    };
    // 重置表单状态
    // const resetFormState = () => {
    //   formState.id = ''
    //   formState.menuId = ''
    //   formState.name = ''
    //   formState.resType = 1
    //   formState.parentId = ''
    //   formState.priority = 1
    //   formState.permission = ''
    //   formState.icon = ''
    //   formState.url = ''
    // }
    // 删除菜单
    // const handleDelete = async (record: MenuItem) => {
    //   try {
    //     // 调用删除API
    //     await deleteResource([{ id: record.id, resType: record.resType }])
    //     message.success('删除成功')
    //     fetchMenuList()
    //   } catch (error) {
    //     console.error('删除失败', error)
    //     message.error('删除失败')
    //   }
    // }
    // 取消表单
    const handleModalCancel = () => {
      modalVisible.value = false;
    };
    // 获取资源类型文本
    const getResTypeText = resType => {
      const typeMap = {
        1: '一级菜单',
        2: '子菜单',
        3: '按钮'
      };
      return typeMap[resType] || resType;
    };
    // 行拖拽结束事件
    const rowDragendEvent = ({
      newRow,
      oldRow,
      dragPos
    }) => {
      // 准备请求参数
      const params = {
        id: oldRow.id,
        resType: oldRow.resType,
        targetRowId: newRow.id,
        targetRowType: dragPos // 拖动至目标位置行的上top、下bottom
      };
      // 调用排序接口
      sortResource(params).then(res => {
        if (res.code === OK) {
          message.success('排序成功');
          // 刷新列表
          fetchMenuList();
        }
      }).catch(err => {});
    };
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_vxe_column = _resolveComponent("vxe-column");
      const _component_a_space = _resolveComponent("a-space");
      const _component_vxe_table = _resolveComponent("vxe-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_button, {
        type: "primary",
        class: "add-menu-btn",
        onClick: handleAddMenu
      }, {
        default: _withCtx(() => [_createTextVNode("新增菜单")]),
        _: 1
      }), _createVNode(_component_vxe_table, {
        border: "",
        ref_key: "tableRef",
        ref: tableRef,
        loading: loading.value,
        "row-config": rowConfig,
        "row-drag-config": rowDragConfig,
        "column-config": columnConfig,
        "tree-config": treeConfig,
        data: tableData.value,
        height: tableHeight.value,
        onRowDragend: rowDragendEvent
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_column, {
          type: "seq",
          width: "60"
        }), _createVNode(_component_vxe_column, {
          field: "name",
          title: "菜单名称",
          "min-width": "180",
          "tree-node": "",
          "drag-sort": ""
        }), _createVNode(_component_vxe_column, {
          field: "resType",
          title: "类型",
          width: "100"
        }, {
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(getResTypeText(row.resType)), 1)]),
          _: 1
        }), _createVNode(_component_vxe_column, {
          field: "permission",
          title: "权限标识",
          width: "150"
        }), _createVNode(_component_vxe_column, {
          field: "url",
          title: "路径",
          width: "150"
        }), _createVNode(_component_vxe_column, {
          field: "priority",
          title: "排序",
          width: "80"
        }), _createVNode(_component_vxe_column, {
          title: "操作",
          width: "60"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_a_space, null, {
            default: _withCtx(() => [_createElementVNode("a", {
              onClick: $event => handleEdit(row)
            }, "编辑", 8, _hoisted_2)]),
            _: 2
          }, 1024)]),
          _: 1
        })]),
        _: 1
      }, 8, ["loading", "row-config", "row-drag-config", "column-config", "tree-config", "data", "height"]), _createVNode(MenuFormModal, {
        ref_key: "menuFormModalRef",
        ref: menuFormModalRef,
        visible: modalVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => modalVisible.value = $event),
        "modal-type": modalType.value,
        "menu-data": formState,
        "parent-menu-options": parentMenuOptions.value,
        "sub-menu-options": subMenuOptions.value,
        onCancel: handleModalCancel,
        onSuccess: fetchMenuList
      }, null, 8, ["visible", "modal-type", "menu-data", "parent-menu-options", "sub-menu-options"])]);
    };
  }
});